jQuery(document).ready(function ($) {
	// Simple acc functionality
	$('.acc__group button').on('click', function () {
		// If item clicked on is open, close it
		if ($(this).closest('.acc__group').hasClass('active')) {
			$(this).closest('.acc__group').removeClass('active');
			$(this).closest('.acc__group').find('.acc__content').slideUp();
		} else {
			// Otherwise, close all others and open the one clicked on
			$('.acc__group').removeClass('active');
			$('.acc__content').slideUp();

			$(this).closest('.acc__group').addClass('active');
			$(this).closest('.acc__group').find('.acc__content').slideToggle();
		}
	});
});
